import { useMemo } from 'react';

export const useFooterLinks = () => {
  const links = useMemo(() => ({
    quickLinks: ['About Us', 'Services', 'Contact', 'FAQs'],
    resources: ['Forms', 'Guidelines', 'Publications', 'Reports'],
    legal: ['Privacy Policy', 'Terms of Use', 'Disclaimer', 'Sitemap']
  }), []);

  return links;
};